import { render, staticRenderFns } from "./RevokeApiKeysButton.vue?vue&type=template&id=3a3af40d&scoped=true"
import script from "./RevokeApiKeysButton.vue?vue&type=script&lang=js"
export * from "./RevokeApiKeysButton.vue?vue&type=script&lang=js"
import style0 from "./RevokeApiKeysButton.vue?vue&type=style&index=0&id=3a3af40d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3af40d",
  null
  
)

export default component.exports